export default __webpack_public_path__ + "static/media/vw.bd452d4f.jpg";